<template>
	<div v-bl-layout="'start center no-wrap 0'" :tabindex="tabindex ? tabindex : -1" ref="container">
		<template v-for="level in field.options.levels" :key="level.level">
			<template v-if="field.options.levels.length > 1">
				<span class="first"></span>
				<b>{{ level.level }}</b>
				<span class="last"></span>
			</template>
			<BlStandaloneField type="choice" :label="label" v-model="model[level.level].packaging" @change="setFieldValue()" :options="{choices: level.packagings}" :required="isRequired(level.level)" :ref="el => fieldRefs[level.level] = el" />
		</template>
	</div>
</template>

<script>
export default {
	name: 'BlFormFieldStockpackaging',
	props: ['field', 'tabindex'],
	data() {
		return {
			model: JSON.parse(JSON.stringify(this.field.value)),
			label: this.field.label.replace('*', ''),
			fieldRefs: {}
		}
	},
	created() {
		this.field.emitter.focus.subscribe(() => {
			for(let level of this.field.options.levels) {
				if(this.isRequired(level.level)) {
					this.fieldRefs[level.level].field.emitter.focus.emit()
					break
				}
			}
		})
		this.field.emitter.change.subscribe(() => this.model = JSON.parse(JSON.stringify(this.field.value)))
		this.setFieldValue()
	},
	methods: {
		isRequired(level) {
			if(this.model[level + 1]?.packaging) return true
			if(level != 1 || !this.field.options.required) return false
			return !this.field.options.levels.filter(l => this.model[l.level].packaging).length
		},
		setFieldValue() {
			let hasValue = false
			for(let level of this.field.options.levels) {
				if(this.model[level.level]?.packaging) {
					hasValue = true
					break
				}
			}
			this.field.setValue(hasValue ? JSON.parse(JSON.stringify(this.model)) : null, false)
		}
	}
}
</script>

<style scoped>
	div > b {
		border: 1px solid var(--bl-border);
		border-radius: 50px;
		width: 23px;
		text-align: center;
		line-height: 23px;
		font-size: 16px;
		margin-top: 5px;
		background-color: var(--bl-surface);
	}

	div > span:first-child {
		display: none;
	}

	div > span.first {
		border-bottom: 1px solid var(--bl-border);
		min-width: 20px;
		margin-top: 4px;
	}

	div > span.last {
		border-bottom: 1px solid var(--bl-border);
		min-width: 10px;
		margin-top: 4px;
	}
</style>